import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';
import { OrganisationUnit, Product, TenantHierarchy } from '@app/models';
import { useRawGetOrganisationHierarchy } from './UseRawGetOrganisationHierarchy';
import { productBaseUrl } from '../BaseUrls';
import { useGet } from '../../HttpClient';

const pillarCode = "tms";
 
export function useProductWithHierarchy() {
  const get = useGet(true, pillarCode);
  const getProducts = () => get<Product[]>(`${productBaseUrl}/products`);
  const getOrganisationHierarchy = useRawGetOrganisationHierarchy();
  return useQueryWithErrorHandling({
    queryKey: ['get-products'],
    queryFn: async () => {
      const [ouHierarchyResp, productsResp] = await Promise.all([getOrganisationHierarchy(), getProducts()]);
      return productsWithHierarchy(productsResp, ouHierarchyResp);
    },
  });
}

function productsWithHierarchy(productsResp: Product[], ouHierarchyResp: TenantHierarchy) {
  return productsResp
    .map((product) => {
      if (ouHierarchyResp?.organisationUnit) {
        const ou = findParentOu(ouHierarchyResp.organisationUnit, product.productId);
        return { ...product, parent: ou };
      }
      return product;
    })
    .sort((a, b) => a.parent?.name.localeCompare(b.parent?.name));
}

function findParentOu(organisationUnit: OrganisationUnit, productId: string) {
  if (organisationUnit.products.indexOf(productId) !== -1) {
    return organisationUnit;
  }
  for (const child of organisationUnit.children) {
    const result = findParentOu(child, productId);
    if (result) {
      return result;
    }
  }
}
